/** @jsxImportSource @emotion/react */

import { useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import withPlatformCheck from 'HOCs/withPlatformCheck'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { CMSBoosterPages, CMSScreenshotPages } from '__generatedTypes__/globalTypes'
import { PlatformSlug } from 'constants/consts'
import NotFound from 'components/NotFound'
import { isTestimonialPageAvailable } from 'pagesNew/Testimonials/platformConfig'
import { Form } from './components/Form'
import * as classes from './styles'

const PAGE_PARAM = 'page'

export const UPGRADE_PAGE_TAB = {
  id: CMSScreenshotPages.UpgradePage,
  title: 'Upgrade',
}

export const SUCCESS_STORIES_PAGE_TAB = {
  id: CMSScreenshotPages.SuccessStory,
  title: 'Success Stories',
}

export const CRASH_COURSE_PAGE_TAB = {
  id: CMSScreenshotPages.CrashCourses,
  title: 'Crash Course',
}

const REVIEWS_PAGE_TAB = {
  id: CMSScreenshotPages.Review,
  title: 'Reviews',
}

const TABS = [UPGRADE_PAGE_TAB, SUCCESS_STORIES_PAGE_TAB, REVIEWS_PAGE_TAB, CRASH_COURSE_PAGE_TAB]

type Props = {
  platform: Platform
}

const ScreenshotReviews = withPlatformCheck(({ platform }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabs = useMemo(
    () =>
      TABS.filter((tab) =>
        isTestimonialPageAvailable(platform.slug as PlatformSlug, tab.id as unknown as CMSBoosterPages)
      ),
    [platform]
  )
  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const initialParamId = searchParams.get(PAGE_PARAM)

    if (initialParamId) {
      const selectedTab = tabs.find(({ id }) => id === initialParamId)

      return selectedTab || tabs[0]
    }

    return tabs[0]
  })

  const handleChangeTab = (newTab: TabsItem) => {
    setActiveTab(newTab)

    searchParams.set(PAGE_PARAM, newTab.id)
    setSearchParams(searchParams, { replace: true })
  }

  if (!tabs.length || !activeTab) {
    return <NotFound />
  }

  return (
    <>
      <Typography variant="body2" css={classes.title}>
        Page
      </Typography>
      <TabsNavigation tabs={tabs} value={activeTab} onChange={handleChangeTab} css={classes.tabs} />
      <Form platformId={platform.id} platformSlug={platform.slug} page={activeTab.id as CMSScreenshotPages} />
    </>
  )
})

export default ScreenshotReviews
